import { initStep1 } from './step1'
import { initStep2 } from './step2'
import { initStep3 } from './step3'
import { initThankYouPage } from './thankYouPage'

export function initCart() {
    initGlobalCart()
    initStep1()
    initStep2()
    initStep3()
    initThankYouPage()

    // document.addEventListener('ShoptetDOMCartContentLoaded', initGlobalCart)
}

function initGlobalCart() {
    cartGlobalTextChanges()
    moveCartElements()
    checkoutSidebar()
    limitSidebarMaxTopPos()
    wrapCartContent()
    addEmptyCartBanner()
}

function cartGlobalTextChanges() {
    // $('.back-to-shop').text(_t('cart.backToShop'))
}

function wrapCartContent() {
    if ($('.id--15').length) return
    $('.content-inner').wrapInner('<div id="cart-wrapper"></div>')
}

function moveCartElements() {
    const nextStepBack = $('.next-step-back').clone()
    const target = $('.id--9').length > 0 ? '.cart-inner' : '#checkoutContent'

    nextStepBack.appendTo(target).wrap('<div class="next-step-back"></div>')

    $('.top-navigation-bar .container').prepend('<a href="/" class="cart-logo"><img src="/user/documents/able-images/cart/logo-cart.svg" alt="Abamal" /></a>');
    $('.navigation-buttons .login').appendTo('.top-navigation-bar .container')
}

/*
 * Nastavuje aktuální pozici sidebaru na základě výšky obsahu a sidebaru.
 * Maže styl top pokud je sidebar větší než obsah.
 * Nastavuje top pozici na scroll až do maximální možné top pozice, což je velikost obsahu
 */
function setCheckBarPos() {
    if ($('.id--15').length) return

    let checkoutContentHeight = $('#checkoutContent').height()
    const checkoutSidebarHeight = $('#checkoutSidebar').height()
    let maxTopPos = Math.max(0, checkoutContentHeight - checkoutSidebarHeight)
    let topValue = parseInt(shoptet.checkout.$checkoutSidebar.css('top'), 10)

    if (topValue <= 0) {
        shoptet.checkout.$checkoutSidebar.removeAttr('style')
    }

    if (topValue > maxTopPos) {
        shoptet.checkout.$checkoutSidebar.css('top', `${ maxTopPos }px`)
    }
}

/*
 *Omezuje maximální absolutní top pozici sidebaru při posuvu stránky.
 *zachycuje událost scroll a aktualizuje pozici bočního panelu pomocí funkce 'setCheckBarPos'.
 */
function limitSidebarMaxTopPos() {
    if ($('.id--15').length) return
    if ($('.id--9').length) return

    const originalHandleWithSidebar = shoptet.checkout.handleWithSidebar
    $(window).unbind('scroll')
    $(window).bind('scroll', function () {
        shoptet.abilities.feature.fixed_header = true
        originalHandleWithSidebar.apply(this, arguments)
        requestAnimationFrame(function () {
            setCheckBarPos()
        })
    })
}

// Předělává názvy produktů na správný formát a přidává názvy značek a případně informaci o tom, že produkt je dárek zdarma.
function checkoutSidebar() {
    const cartProducts = $('#checkoutSidebar .order-summary-item');
    const giftProducts = $('#checkoutSidebar .gift-items');

    cartProducts.each(function () {
        const productName = $(this).find('.cart-item-name');
        productName.wrap('<div class="product-name"></div>');
    });

    if (giftProducts.length) {
        giftProducts.each(function () {
            const productName = $(this).find('.cart-item-name');
            productName.before(`<div class="product-gift">Gratisgeschenk!</div>`);
        });
    }
}

export function injectRecapImages() {
    const map = JSON.parse(localStorage.getItem('cartImageMap') || '{}')
    Object.entries(map).forEach(([sku, url]) => {
        const item = $(`#summary-box .order-summary-item[data-micro-sku="${ sku }"]`)
        if (item.length && !item.find('.recap-image').length) {
            item.find('.product-name')
                .first()
                .prepend(
                    `<img src="${ url }" class="recap-image" width="64" height="64" style="border-radius: 10px;border: 1px solid #F5F5F5;">`
                )
        }
    })

    $('.able-cart-upsell .product').each(function () {
        const product = $(this)
        const identifier = product.find('.p').data('micro-identifier')
        const imageUrl = product.find('.image img').attr('src')

        if (identifier && imageUrl) {
            const map = JSON.parse(localStorage.getItem('cartImageMap') || '{}')
            map[identifier] = imageUrl
            localStorage.setItem('cartImageMap', JSON.stringify(map))

            $(`#summary-box .order-summary-item[data-micro-identifier="${ identifier }"]`).each(function () {
                const cartItem = $(this)

                if (cartItem.find('.recap-image').length) return

                cartItem.prepend(
                    `<img src="${ imageUrl }" class="recap-image" width="64" height="64" style="border-radius: 16px;border: 1px solid #F5F5F5;">`
                )
            })
        }
    })
}

export function addMoveRecapElements() {
    const cartData = getShoptetDataLayer('cart');

    $('.order-summary-item[data-micro="cartItem"]').each(function () {
        const item = $(this);
        const dataId = item.attr('data-micro-identifier');
        const product = cartData.find(p => p.guid === dataId);

        const itemName = item.find('.cart-item-name');
        const itemAmount = item.find('.cart-item-amount');

        if (itemName.length && itemAmount.length && product) {
            const wrapper = $('<div class="cart-recap-wrapper"></div>');

            itemAmount.after(wrapper);

            wrapper.append(itemAmount);
            wrapper.appendTo(itemName);
        }
    });
}

function addEmptyCartBanner() {

    if ($('.cart-is-empty').length) {

        const productsBanner = $('.help-banner');
        const contentWrapper = $('#content-wrapper');

        if (productsBanner.length && contentWrapper.length) {
            const container = $('<div class="container"></div>');
            container.append(productsBanner);
            contentWrapper.after(container);
        }
    }
}